import { baseFetchToken, baseFetchTokenFullResponse } from './BaseSaga'
import AttractionPromoActions from '../Redux/AttractionPromoRedux'
import { getToken } from '../Services/GetToken'

export function * getAttractionPromo (api, action) {
  yield baseFetchTokenFullResponse(
    api.getAttractionPromo,
    action.data,
    getToken,
    AttractionPromoActions.attractionPromoSuccess,
    AttractionPromoActions.attractionPromoFailure
  )
}

export function * postAttractionPromo (api, action) {
  yield baseFetchToken(
    api.postAttractionPromo,
    action.data,
    getToken,
    AttractionPromoActions.postAttractionPromoSuccess,
    AttractionPromoActions.postAttractionPromoFailure
  )
}

export function * putAttractionPromo (api, action) {
  yield baseFetchToken(
    api.putAttractionPromo,
    action.data,
    getToken,
    AttractionPromoActions.putAttractionPromoSuccess,
    AttractionPromoActions.putAttractionPromoFailure
  )
}

export function * deleteAttractionPromo (api, action) {
  yield baseFetchToken(
    api.deleteAttractionPromo,
    action.data,
    getToken,
    AttractionPromoActions.deleteAttractionPromoSuccess,
    AttractionPromoActions.deleteAttractionPromoFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/AttractionPromoSagas.js